import { render } from "./wInputNumber.vue?vue&type=template&id=79ea9e1a&ts=true"
import script from "./wInputNumber.vue?vue&type=script&lang=ts"
export * from "./wInputNumber.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__